import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {SignatureState} from '@/store/types'
import store from 'store'

type SignatureGetter = GetterTree<SignatureState, any>
type SignatureMutation = MutationTree<SignatureState>
type SignatureAction = ActionTree<SignatureState, any>

const state: SignatureState = {
  signatures: [],
}

const getters: SignatureGetter = {
  signatures: (state) => state.signatures,
  signature: (state, getters, rootState) => {
    if (!rootState.tasks.task) {
      return null
    }
    const signature = state.signatures.find((s) => {
      return s.task_id === rootState.tasks.task.id
    })
    return signature !== undefined ? signature : null
  },
}

const mutations: SignatureMutation = {
  setSignature: (state, signature) => {
    state.signatures.push(signature)
    store.set('signatures', state.signatures)
  },
  setSignatures: (state, signatures) => {
    state.signatures = signatures
  },
  removeTaskSignature: (state, taskId) => {
    state.signatures = state.signatures.filter((s) => s.task_id !== taskId)
    store.set('signatures', state.signatures)
  },
}

const actions: SignatureAction = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
